<template>
  <div class="headerBox">
    <img height="60" src="../assets/image/newImage/logo.png" alt="" />
    <ul>
      <li
        v-for="(item, index) in navList"
        :key="index"
        :class="[item.path == currentPath ? 'active' : '']"
        @click="jumpRoute(item)"
      >
        {{ item.name }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navList: [
        {
          name: "Inicio",
          path: "/Inicio",
        },
        {
          name: "Sobre nosotros",
          path: "/Sobre",
        },
        {
          name: "FAQ",
          path: "/Ayuda",
        },
        {
          name: "Descarga la app",
          path: "",
        },
        {
          name: "Aviso de privacidad",
          path: "/Aviso",
        },
        {
          name: "Términos",
          path: "/Uso",
        },
        {
          name: "Evita fraude",
          path: "/fraude",
        },
        {
          name: "Libro de reclamaciones",
          path: "/libro",
        },
      ],
      currentPath: "",
    };
  },
  methods: {
    jumpRoute(row) {
      if (!row.path)
        return window.open(
          "https://www.credisol.pe/credisol.apk"
        );
      if (row.path !== this.currentPath) {
        this.currentPath = row.path;
        this.$router.push(row.path);
      }
    },
  },
  mounted() {
    this.currentPath = this.$route.fullPath;
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
  list-style: none;
}
.headerBox {
  display: flex;
  padding: 0 10% 0 15%;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 75px;
  background-color: inherit;
  // background: linear-gradient(307deg, #f98043 0%, #c90000 100%);
  ul {
    display: flex;
    li {
      cursor: pointer;
      display: flex;
      padding: 0 15px;
      align-items: center;
      justify-content: center;
      text-align: center;
      height: 71px;
      min-width: 71px;
      max-width: 150px;
      border-radius: 50%;
      margin-right: 10px;
      color: #fff;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      &:last-child {
        margin-right: 0;
      }
      &:hover {
        background-color: #fff;
        color: #c90000;
      }
    }

    .active {
      background-color: #fff;
      color: #c90000;
    }
  }
}
</style>
